import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';

import { requestSeats, selectSeat, showSeatMessage, removeSeatMessage, requestSetSelectedSeats, deSelectSeat, hideModal, hideWizardModal, showWizardModal} from '../store/seats';


import { setSelectedSeats, SET_SELECTED_SEATS } from '../store/globals';

import { removeSessionId } from '../store/payments';

import Return from '../components/Return';
import SeatList from '../components/SeatList';
import Seat from '../components/Seat';
import SeatMessage from '../components/SeatMessage';
import Loader from '../components/Loader';
import Movie from '../components/Movie';
import LocalRedirect from '../components/LocalRedirect';
import TagManager from 'react-gtm-module';
import Modal from '../components/Modal'
import WizardModal from '../components/WizardModal'
import { CautionIcon } from '../components/Icons'
import '../static/css/modal-utils.css';
import htmlParse from 'html-react-parser'; 

const COLORS = {
  blue: '#5495D2',
  darkBlue: '#002169',
  gray: '#7c7c7c',
  darkGray: '#6a6a6a',
  black: '#1c1c1b',
  deeperBlack: '#000000',
  yellow: '#ffc526',
  red: '#f64e4e',
  darkRed: '#ba0a0a',
  purple: '#8234cf',
  lemmonGreen: '#97bf00',
  whiteGray: '#9a9a9a',
  white: '#000',
  navy:'#08285b',
  lightRed: '#ba0a0a'
};

const SEATS_AREA_COLORS = 
[
  {
    name:"zonaA",
    areaNumber : 1,
    colorHEX: '#9a9a9a'
  },
  {
    name:"zonaB",
    areaNumber : 2,
    colorHEX: '#3471C4'
  },
  {
    name:"zonaC",
    areaNumber : 3,
    colorHEX: '#144DB4'
  },
  {
    name:"zonaD",
    areaNumber : 4,
    colorHEX: '#0039A0'
  },
  {
    name:"zonaE",
    areaNumber : 5,
    colorHEX: '#295998'
  }
];

class Seats extends Component {
  state = {
    goToPayment: false,
    showWizardModal: true,
  }

  componentDidMount() {
    const { showtimeVistaId, cinemaVistaId, sessionId, selectedSeats } = this.props;
    if (this.props.seatsAreas.length === 0) {
      this.props.requestSeats(cinemaVistaId, showtimeVistaId, sessionId, this.props.selectedTickets, selectedSeats.length === 0);
    }
    this.selectedCategoryCodes = new Set(this.props.selectedTickets.map(ticket => ticket.area_category_code));

    const tagManagerArgs = {
      dataLayer: {
        item_name: this.props.showtime.movie.name,
        event: 'asientos',
        items: [{
          step: 2,
          action: "checkout"
        }]
      }
    }
    const tagManagerPageView = {
      dataLayer: {
        item_name: this.props.showtime.movie.name,
        event: "pageView",
        path: '/visSelectSeats'
      }
    }

    TagManager.dataLayer(tagManagerArgs);
    TagManager.dataLayer(tagManagerPageView);
    this.props.showWizardModal()
  }

  handleSelectedSeat = (selectedSeat, status, color) => {
    if (COLORS.lemmonGreen === color) {
      this.props.deSelectSeat(selectedSeat, status);
      return;
    }
    if (status === 'Special') {
      this.props.showSeatMessage();
    }
    if ((status === 'Sold' || status === 'Reserved' || status === 'House' || status === 'Broken') ||
      !this.selectedCategoryCodes.has(selectedSeat.area_category_code)) {
      return;
    }
    this.props.selectSeat(selectedSeat);
  };

  handleSelectedSeats = () => {
    this.setState(prevState => ({ ...prevState, goToPayment: true }));
    this.props.removeSessionId();
    const { showtimeVistaId, cinemaVistaId, sessionId, selectedSeats } = this.props;
    this.props.requestSetSelectedSeats(cinemaVistaId, showtimeVistaId, sessionId, selectedSeats);
  }

  handleCloseSeatMessage = () => { this.props.removeSeatMessage(); }

  // Promotional Movie Icons at seats
  nestedMovieIcon() {
    const iconRoutes = this.props.icons.filter(icon => icon.type.toLowerCase().includes("personalizado")).map(icon => icon.resource)
    console.log(iconRoutes);
    const maxIndex = iconRoutes.length - 1
    let currentIconIndex = 0

    const next = () => {
      if(currentIconIndex > maxIndex) currentIconIndex = 0
      const route = iconRoutes[currentIconIndex]
      currentIconIndex++
      return route
    }
    
    return { next }
  }

  renderSeats() {
    const { selectedSeats, seatsLayout, maxColumnCount, globalError } = this.props;
    const movieIcon = this.nestedMovieIcon()
    const neededIcons = []
    const spanishAlphabet = 'ABCDEFGHIJKLMNÑOPQRSTUVWXYZ';

    Object.keys(seatsLayout)
      .sort((a, b) => spanishAlphabet.indexOf(a) - spanishAlphabet.indexOf(b))
      .forEach(letter => {
        const row = seatsLayout[letter]
        const filteredRow = row.filter(seat => seat.status === "Sold" || seat.status === "Reserved")
        filteredRow.forEach(_ => neededIcons.push(movieIcon.next()))
      })
    // Reverse 
    neededIcons.reverse()

    if (globalError !== null && globalError.status_code > 0) return <LocalRedirect to={{ pathname: '/error', state: { message: globalError.message } }} />;

    const seatWidth = (100 / (maxColumnCount + 1) - (window.innerWidth < 768 ? 0.38 : 0.18));

    let iconCounter = 0
    //console.time('render layout');
    const renderLayout = Object.keys(seatsLayout).sort((a, b) => spanishAlphabet.indexOf(a) - spanishAlphabet.indexOf(b)).map(letter => {
      const rows = seatsLayout[letter];
      return (
        <SeatList key={letter}>
          <Seat letter={letter} width={`${seatWidth}%`} />
          {
            rows.map((seat, index) => {
              let color = COLORS.whiteGray;
              let widthSeat = seatWidth;
              // Mario movie
              let iconRoute = null
              if (seat.status !== 'noSeat') {
                switch (seat.status) {
                  case "Sold":
                  case "Reserved":
                    color = COLORS.lightRed
                    if(this.props.movieHasIcons && this.props.showSeatsIcons && iconCounter < neededIcons.length) {
                      iconRoute = neededIcons[iconCounter]
                      iconCounter++
                    }
                  break;

                  case "Broken":
                  case "House":
                    color = COLORS.red;
                  break;

                  case "Special":
                    color = COLORS.navy;
                  break;
                
                  default:
                    try {
                        let areaNumber = seat.position.area_number;
                        if (areaNumber) {
                          if (selectedSeats.find(x => x.area_category_code === seat.position.area_category_code)){
                            color = COLORS.whiteGray;
                          }
                          else{
                            color = COLORS.purple;
                          }
                        }
                    } catch (error) {
                      console.log(error);
                    }
                  break;
                }
                for (let i = 0; i < selectedSeats.length; i += 1) {
                  const selectedElem = selectedSeats[i];
                  
                  for (let j = 0; j < selectedElem.selected_seats.length; j += 1) {
                    if (selectedElem.selected_seats[j].row_index === seat.position.row_index
                      && selectedElem.selected_seats[j].column_index === seat.position.column_index
                      && selectedElem.selected_seats[j].area_category_code == seat.position.area_category_code ) {
                      color = COLORS.lemmonGreen;
                    }
                  }
                }

                return (
                  <Seat
                    key={`${letter}-${seat.position.column_index}-${seat.position.row_index}`}
                    id={seat.id}
                    color={color}
                    width={`${widthSeat}%`}
                    physical_name={letter}
                    position={seat.position}
                    status={seat.status}
                    colLetter={letter}
                    onSelected={this.handleSelectedSeat}
                    typeSeat={"trad"}
                    iconRoute={iconRoute}
                    isSpecial={seat.status === "Special"}
                  />
                );
              }
         
              
              return <Seat empty={true} width={`${seatWidth}%`} key={index} typeSeat={"trad"} />;
            })
          }
          
        </SeatList>
      );
    });
    //console.timeEnd('render layout');

    return renderLayout;
  }

  renderButton() {
    const isMobileOrDesktop = this.props.isMobileOrDesktop;
    const ticketsLength = this.props.selectedSeats.reduce((acc, seatCat) => acc + seatCat.seats_to_allocate, 0);
    const seatsLength = this.props.selectedSeats.reduce((acc, seatCat) => acc + seatCat.selected_seats.length, 0);
    const seatsEqualTickets = seatsLength === ticketsLength;

    return <Fragment>
      <button type="button" disabled={this.props.isSeatsLoading || !seatsEqualTickets ? true : false} onClick={this.handleSelectedSeats} className="btn btn--primary" style={{borderRadius: '30px', background: "lineargradient('to right', #d3168f, #f64e4e);"}}>
        {isMobileOrDesktop ? 'SIGUIENTE' : 'SIGUIENTE'}
      </button>
      {!isMobileOrDesktop &&
        <button type="button" disabled={this.props.isSeatsLoading || !seatsEqualTickets ? true : false} onClick={this.handleSelectedSeats} className="btn btn--border btn--next">
          SIGUIENTE
      </button>}
    </ Fragment>;
  }

  renderModal() {
    return this.props.modalIsVisible ? (
      <Modal
        className="modal--main modal-errors"
        accept={this.props.hideModal}
        acceptText="OK, ENTENDIDO"
        title="Butaca no disponible"
        icon={<CautionIcon />}
        iconWidth="21px"
      >
        <p className="text">{this.props.modalMessage}</p>
      </Modal>
    ) : null;
  }

  renderModalWizard() {
    const { showtime } = this.props;

    const alerts = (showtime?.showtimeInfo?.alerts || []).filter(x => x.section == "seats-image").sort(function (a, b) {
      if (a?.priority > b?.priority) {
        return 1;
      }
      if (a?.priority < b?.priority) {
        return -1;
      }
      return 0;
    }).map((x,i)=>{
      return {
        id:i++,
        img: x?.image,
        title: x?.title,
        subtitle: x?.description,
        description: x?.message
      }
    })


    return this.props.modalWizardIsVisible && alerts.length>0 ? (
      <WizardModal
        className="modalWz--main modalWz-errors"
        cancel={this.props.hideWizardModal}
        acceptText="OK, ENTENDIDO"
        title="ATENCIÓN"
        icon={<CautionIcon />}
        iconWidth="21px"
        steps={alerts} 
      >
       
      </WizardModal>
    ) : null;
  }
  render() {
    const { seatsAreas, seatsSelectedResponse, seatsMessage, isMobileOrDesktop, isSeatsLoading, seatsLayout, hasSeats } = this.props;
    if (
      (typeof seatsSelectedResponse.status_code !== 'undefined' &&
        seatsSelectedResponse.status_code === 0 &&
        this.props.paymentSessionId === null) || !hasSeats
    ) {
      return <LocalRedirect to="/pago" />;
    }

    function parseBackScreenMessage(message = "", deleteBr = false, isDesktop = true){
        try {
            if(message){
              if (deleteBr && !isDesktop) {
                message = message.replace('<br />','');
              }
            }
          return htmlParse(message);
        } catch (error) {
            return "";
        }
     }
     
    
      let INVALID_DESCRIPTION_SEAT_HEADER = 
      [
        { copy : "GARANTÍA" }, { copy : "GARANTIA" },
        { copy : "DEFAULT" }, { copy : "SALA " }, { copy : "SALA" },
        { copy : "VIP" }, { copy : "HFR" },
        { copy : "4DX" }, { copy : "2D" }, { copy : "3D" },
        { copy : "ORI" }, { copy : "DIG" },
        { copy : "SUB" }, { copy : "ESP" }, { copy : "ATMOS" },
        { copy : "LED" }, { copy : "SCREENX" },
        { copy : "PLUUS" }, { copy : "XE" }, { copy : "MACRO" },
        { copy : "IMAX" }, {copy : "TRADICIONAL"},{copy : "NORMAL"}
      ];

      function validateAreaDescription(descriptionSeatService){
        try {
          if (descriptionSeatService && typeof(descriptionSeatService) === "string") {

              descriptionSeatService = descriptionSeatService.toUpperCase();

              let invalidaDescriptionTemp = [];
              INVALID_DESCRIPTION_SEAT_HEADER.forEach(item => {
                invalidaDescriptionTemp.push({ copy : item.copy });
                invalidaDescriptionTemp.push({ copy : " " + item.copy });
                invalidaDescriptionTemp.push({ copy : item.copy + " " });
              });
     
              for (let index = 0; index < 50; index++) {
                  let lobby =  { copy : "SALA " + index };
                  invalidaDescriptionTemp.push(lobby);
              }

              let result = invalidaDescriptionTemp.find(desc => descriptionSeatService.indexOf(desc.copy.toUpperCase()) !== -1);
              
              return result === null || result === undefined;
          }
          return false;
        } catch (error) {
          console.log(error);
          return false;
        }
      }

     let textLoader = this.state.goToPayment ? "pago" : "butacas";
     if (isSeatsLoading || seatsLayout.length === 0) return <Loader text={textLoader} />;
     
      const soldIconReference = this.props.icons.find(icon => icon.type.toLowerCase() === "ocupado")

    return (
      <Fragment>
     
        {isMobileOrDesktop && <Return to="/entradas" />}

        <div className="container container--mid seats">
          {this.props.isMobile && <Movie />}

          <h1 className="title">Selecciona tus butacas</h1>
          <p className="text">Para elegir un lugar da clic en la butaca deseada.</p>

          <ul className="nostyle seats__types">
            <Seat HTMLElement='div' color="#9a9a9a"><span className="text">Disponible</span></Seat>
            <Seat HTMLElement='div' color="#97bf00"><span className="text">Selección</span></Seat>
            {this.props.movieHasIcons && this.props.showSeatsIcons && soldIconReference
            ? <Seat HTMLElement='div' isTopReference={true} iconRoute={soldIconReference.resource}><span className="text">Vendido</span></Seat>
            : <Seat HTMLElement='div' color="#ba0a0a"><span className="text">Vendido</span></Seat>}
            <Seat HTMLElement='div' color="#08285b" isSpecial={true}><span className="text">Necesidades Especiales</span></Seat>
            <Seat HTMLElement='div' color="#f64e4e"><span className="text">Deshabilitado</span></Seat>
          </ul>

          <div className="seats__select">
            {seatsMessage ?
              <SeatMessage onCloseMessage={this.handleCloseSeatMessage}>
                <svg width="34" height="40" viewBox="0 0 34 40">
                  <g fill="#0C5BA1" fillRule="nonzero">
                    <path d="M13.012 36.957c-5.554 0-10.074-4.496-10.074-10.022 0-3 1.334-5.694 3.44-7.533l-.633-3.2C2.282 18.53 0 22.471 0 26.934 0 34.073 5.837 39.88 13.012 39.88c4.937 0 9.24-2.749 11.445-6.789l-1.82-3.196a10.086 10.086 0 0 1-9.625 7.062z" />
                    <path d="M31.57 31.914l-1.932.96-5.51-9.685a1.68 1.68 0 0 0-1.462-.848H11.665l-.413-2.088h8.056c.928 0 1.68-.747 1.68-1.67 0-.922-.752-1.67-1.68-1.67h-8.717l-1.178-5.96A1.678 1.678 0 0 0 7.44 9.636a1.67 1.67 0 0 0-1.323 1.962l2.519 12.736a1.677 1.677 0 0 0 1.647 1.348h11.404l5.814 10.219a1.68 1.68 0 0 0 2.212.67l3.357-1.67a1.666 1.666 0 0 0 .751-2.24 1.683 1.683 0 0 0-2.252-.747z" />
                    <ellipse cx="9.13" cy="4.072" rx="4.093" ry="4.072" />
                  </g>
                </svg>
                <p className="text">Las butacas PMR no cuentan con butaca física. Son espacios adaptados para aquellos clientes con movilidad reducida que acudan con silla de ruedas.</p>
              </SeatMessage>
              : null
            }
            <div className={`${seatsMessage ? 'blur-overlay' : ''}`}>
              <div className="screen">
              <figure>
                <img src= {require(`../static/images/graphic.svg`)} alt="" />
              </figure>
              <span>PANTALLA</span>
              </div>

              <div className="seats__grid">
                {this.renderSeats()}
              </div>
            </div>
          </div>

          {!(isSeatsLoading || seatsLayout.length === 0) && this.renderButton()}

          {!isMobileOrDesktop && <Return to="/entradas" />}
        </div>
        {this.renderModal()}
        {this.renderModalWizard()}
      </Fragment>
    );
  }
}

const mapStateToProps = ({ seats, globals, tickets, payments, ui, showtime }) => {
  const { selected: selectedSeats, isLoading: isSeatsLoading,
    response, maxColumnCount, message: seatsMessage, seatsSelectedResponse, layout: seatsLayout } = seats;

    let message = "";
    if (showtime.showtimeInfo && showtime.showtimeInfo.alerts) {
      const alertMessage = showtime.showtimeInfo.alerts.find(x => x.section == "seats-message");
      if (alertMessage) {
        message = alertMessage.message;  
      }
    }
    let seatsIcons = "";
    if (showtime.settings != null) {
      const alertMessage = showtime.settings.others.show_images
      if (alertMessage) {
        message = alertMessage;  
      }
    }

  return {
    selectedSeats, isSeatsLoading, seatsSelectedResponse,
    seatsMessage, maxColumnCount, seatsLayout,
    seatsAreas: response.seat_layout_data ? response.seat_layout_data.areas : [],
    showtimeVistaId: globals.showtimeVistaId,
    cinemaVistaId: globals.cinemaVistaId,
    sessionId: globals.sessionId,
    globalError: globals.error,
    selectedTickets: tickets.selectedTickets,
    isMobile: ui.isMobile,
    windowSize: ui.size,
    paymentSessionId: payments.sessionId,
    showtime,
    isMobileOrDesktop: (ui.isMobile && ui.size >= 768 && ui.size < 1024) || !ui.isMobile,
    hasSeats: seats.hasSeats,
    showSeatsIcons: seatsIcons,
    icons: showtime.movie.media.length > 0 ? showtime.movie.media : [],
    movieHasIcons: showtime.movie.media.length > 0,
    modalIsVisible: seats.modalIsVisible,
    modalTitle: seats.modalTitle,
    modalMessage: seats.modalMessage,
    modalWizardIsVisible: seats.modalWizardIsVisible,
    backScreenMessage : message
  }
};

export default connect(
  mapStateToProps, {
  requestSeats, selectSeat, showSeatMessage, removeSeatMessage,
  setSelectedSeats, requestSetSelectedSeats, removeSessionId, deSelectSeat,
    hideModal, hideWizardModal, showWizardModal
}
)(Seats);
